import { createTheme } from './createTheme';

import { DARK_MODE, GRAY_SCALE } from 'constants/ThemeConstant';

import { rgba, createOpaqueTableRowColors, buildOpaqueTableRowScopedStyles, getTableRowTokens, getColoredHeaderTableTokens, buildThemeTableSorterScopedStyles, buildThemeCheckboxScopedStyles, buildThemeGroupRowCssVariables, buildThemePaginationScopedStyles, getThemePaginationTokens } from './utils';



const NATIONAL_PRIMARY = '#9F0000';

const NATIONAL_BG = '#FFF8ED';

const NATIONAL_TEXT = '#262626';

const NATIONAL_BORDER = '#E8DCC8';

const NATIONAL_GOLD = rgba('#FFD700', 0.9);
/** Màu nền group-row table */
const NATIONAL_GROUP = '#FFC466';
const NATIONAL_MODULE_ICON = '#FFFFFF';
const NATIONAL_TABLE_ROW_COLORS = createOpaqueTableRowColors(NATIONAL_PRIMARY, GRAY_SCALE.WHITE);



/** Sidebar custom-menu — không dùng token Menu global */

export const nationalDayCustomMenuStyles = `
.side-nav .custom-menu .ant-menu-item:not(.ant-menu-item-selected),
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title {
    color: ${GRAY_SCALE.WHITE} !important;
}
.side-nav .custom-menu .ant-menu-item:not(.ant-menu-item-selected) .ant-menu-item-icon,
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title .ant-menu-item-icon {
    color: ${NATIONAL_GOLD} !important;
}
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title > span .anticon {
    color: ${GRAY_SCALE.WHITE} !important;
}
.side-nav .custom-menu .ant-menu-item-group-title,
.side-nav .custom-menu .ant-menu-item-group-title .nav-item_title {
    color: ${NATIONAL_GOLD} !important;
}
.custom-menu-popup.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected),
.custom-menu-popup.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open):not(.ant-menu-submenu-active) > .ant-menu-submenu-title {
    color: ${GRAY_SCALE.WHITE} !important;
}
.custom-menu-popup.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected) .ant-menu-item-icon,
.custom-menu-popup.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open):not(.ant-menu-submenu-active) > .ant-menu-submenu-title .ant-menu-item-icon {
    color: ${NATIONAL_GOLD} !important;
}
.custom-menu-popup.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open):not(.ant-menu-submenu-active) > .ant-menu-submenu-title > span .anticon {
    color: ${GRAY_SCALE.WHITE} !important;
}
`;



/** Steps điều hướng form (className="step-nav") */

export const nationalDayStepNavStyles = `

.step-nav.ant-steps .ant-steps-item-title {

    color: ${NATIONAL_TEXT} !important;

    font-size: 13px !important;

}

.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-title,

.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-title {

    color: ${NATIONAL_PRIMARY} !important;

    font-weight: 600 !important;

}

.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${NATIONAL_PRIMARY} !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon .anticon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon .anticon {
    color: ${NATIONAL_PRIMARY} !important;
}
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${NATIONAL_BORDER} !important;
}
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon .anticon {
    color: ${GRAY_SCALE.GRAY} !important;
}

`;

export const nationalDayScopedStyles = `

${nationalDayCustomMenuStyles}

${nationalDayStepNavStyles}

${buildThemePaginationScopedStyles(NATIONAL_GOLD, NATIONAL_BORDER)}

.ant-table-wrapper .ant-table-thead > tr > th {

    font-weight: 600;

    text-transform: uppercase;

}
${buildThemeTableSorterScopedStyles(NATIONAL_PRIMARY)}
${buildOpaqueTableRowScopedStyles(NATIONAL_TABLE_ROW_COLORS)}
${buildThemeCheckboxScopedStyles('light')}
${buildThemeGroupRowCssVariables(NATIONAL_PRIMARY, NATIONAL_GROUP, 'light', NATIONAL_BG)}
`;



export const nationalDayTheme = createTheme({

    primaryColor: NATIONAL_PRIMARY,

    successColor: '#52C41A',

    warningColor: '#FA8C16',

    errorColor: '#FF4D4F',



    bgColor: NATIONAL_BG,

    textColor: NATIONAL_TEXT,

    borderColor: NATIONAL_BORDER,

    bodyBg: NATIONAL_BG,

    colorBgLayout: NATIONAL_BG,

    colorBgElevated: GRAY_SCALE.WHITE,

    menuGroupTitleColor: NATIONAL_GOLD,

    moduleMenuBg: NATIONAL_PRIMARY,
    moduleMenuIconColor: NATIONAL_MODULE_ICON,
    moduleMenuItemColor: NATIONAL_MODULE_ICON,

    moduleMenuItemSelectedBg: GRAY_SCALE.WHITE,

    moduleMenuItemSelectedColor: NATIONAL_PRIMARY,

    headerNavColor: NATIONAL_BG,

    siderBg: GRAY_SCALE.WHITE,

    customMenuBg: GRAY_SCALE.WHITE,
    customMenuItemSelectedColor: NATIONAL_TEXT,
    customMenuItemSelectedBg: NATIONAL_BG,
    customMenuItemSelectedIconColor: NATIONAL_PRIMARY,
    customMenuItemSelectedBorderColor: NATIONAL_GOLD,

    footerBg: NATIONAL_PRIMARY,

    footerTextColor: GRAY_SCALE.WHITE,

    componentOverrides: {

        Layout: {

            bodyBg: NATIONAL_BG,

            headerBg: NATIONAL_BG,

            siderBg: GRAY_SCALE.WHITE,

        },

        Menu: {

            darkItemBg: 'transparent',

            darkItemColor: GRAY_SCALE.WHITE,

            darkItemSelectedBg: DARK_MODE.ACTIVE_BG_COLOR,

            darkItemSelectedColor: GRAY_SCALE.WHITE,

            darkItemHoverBg: DARK_MODE.HOVER_BG_COLOR,

            darkItemHoverColor: GRAY_SCALE.GRAY_DARK,

            darkSubMenuItemBg: DARK_MODE.BG_COLOR,

            popupBg: DARK_MODE.BG_COLOR,

            activeBarWidth: 0,

            boxShadowSecondary: DARK_MODE.DROP_DOWN_SHADOW,

        },

        Breadcrumb: {

            itemColor: GRAY_SCALE.GRAY,

            lastItemColor: NATIONAL_PRIMARY,

            linkColor: GRAY_SCALE.GRAY,

            linkHoverColor: NATIONAL_PRIMARY,

            separatorColor: GRAY_SCALE.GRAY,

        },

        Card: {

            colorBgContainer: GRAY_SCALE.WHITE,

            colorTextHeading: NATIONAL_PRIMARY,

            colorText: NATIONAL_TEXT,

            colorBorderSecondary: NATIONAL_BORDER,

            extraColor: NATIONAL_TEXT,

            headerBg: GRAY_SCALE.WHITE,

            actionsBg: GRAY_SCALE.WHITE,

            borderRadiusLG: 22,

        },

        Table: {

            colorText: NATIONAL_TEXT,

            colorTextHeading: GRAY_SCALE.WHITE,

            headerBg: NATIONAL_PRIMARY,

            borderColor: '#F0F0F0',

            ...getColoredHeaderTableTokens(NATIONAL_PRIMARY),

            ...getTableRowTokens(NATIONAL_TABLE_ROW_COLORS),

        },

        Steps: {

            colorPrimary: NATIONAL_PRIMARY,

            colorText: NATIONAL_TEXT,

            colorTextDescription: GRAY_SCALE.GRAY,

        },

        Input: {

            colorBgContainer: GRAY_SCALE.WHITE,

            colorBorder: NATIONAL_BORDER,

            activeBorderColor: NATIONAL_PRIMARY,

            hoverBorderColor: NATIONAL_PRIMARY,

        },
        DatePicker: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorBorder: NATIONAL_BORDER,
            activeBorderColor: NATIONAL_PRIMARY,
            hoverBorderColor: NATIONAL_PRIMARY,
        },

        Select: {
            colorBgContainer: GRAY_SCALE.WHITE,
            selectorBg: GRAY_SCALE.WHITE,
            colorBgElevated: GRAY_SCALE.WHITE,
            optionSelectedBg: rgba(NATIONAL_PRIMARY, 0.1),
            optionActiveBg: rgba(NATIONAL_PRIMARY, 0.06),
            colorBorder: NATIONAL_BORDER,
            activeBorderColor: NATIONAL_PRIMARY,
            hoverBorderColor: NATIONAL_PRIMARY,
        },

        Button: {
            defaultBg: GRAY_SCALE.WHITE,
            defaultHoverBg: GRAY_SCALE.WHITE,
            defaultActiveBg: GRAY_SCALE.WHITE,
            defaultBorderColor: NATIONAL_BORDER,
            defaultHoverBorderColor: NATIONAL_PRIMARY,
            defaultActiveBorderColor: NATIONAL_PRIMARY,
        },
        Pagination: getThemePaginationTokens(NATIONAL_PRIMARY, NATIONAL_BORDER),
        Segmented: {
            trackBg: rgba(NATIONAL_PRIMARY, 0.08),
            itemColor: GRAY_SCALE.GRAY,
            itemHoverColor: NATIONAL_PRIMARY,
            itemSelectedBg: NATIONAL_PRIMARY,
            itemSelectedColor: GRAY_SCALE.WHITE,
        },
    },

});





